import { BiLoaderAlt } from 'react-icons/bi';
import { createIconComponent } from '../createIconComponent';

export const Loader = createIconComponent(BiLoaderAlt);
